let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fU8qX")).then(() => parcelRequire('95O0U'));